import { useState } from "react";
import { Head, useForm } from "@inertiajs/react";

import Button from "/components/Button";
import Switch from "/components/Switch";

export default function MenuItemsIndex({
  menu_items,
}) {
  const initialData = menu_items.reduce(
    (result, currentItem) => (result[currentItem.key] = currentItem) && result,
    {}
  );
  const [items, setItems] = useState(initialData);

  const handlePartialChange = (key, updatedData) => {
    setItems({ ...items, [key]: { ...items[key], ...updatedData } });
  };

  return (
    <>
      <Head>
        <title>Шапка</title>
      </Head>

      <div className="table-header">
        <div className="table-header__left">
          <h2>Шапка</h2>
        </div>
      </div>

      <table className="tbl">
        <thead>
          <tr>
            <th>Пункт меню</th>
            <th>Menu item</th>
            <th>Показать</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(items).map((key) => (
            <MenuItem
              key={key}
              item={items[key]}
              onChange={handlePartialChange}
            />
          ))}
        </tbody>
      </table>
    </>
  );
}

function MenuItem({
  item,
  onChange,
}) {
  return (
    <tr>
      <td>{item.title_ru}</td>
      <td>{item.title_en}</td>
      <td>
        <Switch
          value={item.display}
          name="display"
          url={`/admin/menu_items/${item.id}`}
          onChange={(data) => onChange(item.key, data)}
        />
      </td>
    </tr>
  );
}
